import {CORE_SIZES} from '~/constants/ProductConstants';

const hasLow = sizeArray => sizeArray.some(size => size.stock_status === 'low');

const hasOut = sizeArray => sizeArray.some(size => size.stock_status === 'out');

export function hasSizesLow(sizes) {
  const coreSizes = sizes.filter(size => CORE_SIZES.includes(size.name));
  const hasCoreSizes = !!coreSizes.length;
  return hasCoreSizes ? hasLow(coreSizes) : hasLow(sizes);
}

export function hasSizesOos(sizes) {
  // eventually want to introduce checking if color is active
  const coreSizes = sizes.filter(size => CORE_SIZES.includes(size.name));
  const hasCoreSizes = !!coreSizes.length;
  return hasCoreSizes ? hasOut(coreSizes) : hasOut(sizes);
}

export function getAvailableSizeGroupSizes(itemSizes) {
  return itemSizes.filter(sizeGroups => {
    const availableSizeCount = sizeGroups.sizeValues.filter(
      sizeValue => !sizeValue.unavailable
    );
    return availableSizeCount.length > 0;
  });
}
